import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Projection, CreateScenario, StartPage } from 'pages';
import { Localization } from 'utils';

export const Routers = () => {
    return (
        <Routes>
            <Route path="/" element={<StartPage />} />
            <Route
                path={`/${Localization.UK}/projections`}
                element={<Navigate to={`/${Localization.UK}/projections/population`} replace />}
            />
            <Route
                path={`/${Localization.UK}/projections/:tabId`}
                element={
                    <Projection
                        title={`Segment Opportunity Simulator | UK`}
                        localization={Localization.UK}
                    />
                }
            />
            <Route
                path={`/${Localization.UK}/create_scenario`}
                element={
                    <CreateScenario title={`Create Scenario | UK`} localization={Localization.UK} />
                }
            />
            <Route
                path={`/${Localization.US}/projections`}
                element={<Navigate to={`/${Localization.US}/projections/population`} replace />}
            />
            <Route
                path={`/${Localization.US}/projections/:tabId`}
                element={
                    <Projection
                        title={`Segment Opportunity Simulator | US`}
                        localization={Localization.US}
                    />
                }
            />
            <Route
                path={`/${Localization.US}/create_scenario`}
                element={
                    <CreateScenario title={`Create Scenario | US`} localization={Localization.US} />
                }
            />
        </Routes>
    );
};
